import CityPageTemplate from "../city-template/CityPageTemplate";
import { bowlingGreenOhConfig } from "./data";

export default function BowlingGreenOhPage() {
  return <CityPageTemplate config={bowlingGreenOhConfig} />;
}